import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./lib/auth";
import Header from "./components/site/Header";
import NoBrokerBanner from "./components/site/NoBrokerBanner";
import Footer from "./components/site/Footer";
import Home from "./pages/Home";
import Sell from "./pages/Sell";
import Buy from "./pages/Buy";
import AdDetail from "./pages/AdDetail";
import Admin from "./pages/Admin";
import Login from "./pages/Login";
import Account from "./pages/Account";
import Plans from "./pages/Plans";
import Seller from "./pages/Seller";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function ScrollTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
      <BrowserRouter>
        <ScrollTop />
        <Header />
        <NoBrokerBanner />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/sell" element={<Sell />} />
            <Route path="/buy" element={<Buy />} />
            <Route path="/ad/:id" element={<AdDetail />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/login" element={<Login />} />
            <Route path="/account" element={<Account />} />
            <Route path="/plans" element={<Plans />} />
            <Route path="/seller/:id" element={<Seller />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
          </Routes>
        </main>
        <Footer />
        <Toaster position="top-center" richColors />
      </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
